import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { putData } from "../../../Core/Projects/action";
import { changeData } from '../../../Core/ChangeValues/action';
import styles from '../../../Assets/Styles/Components/Book/Shoots/Card.module.css';

class Card extends Component {
	onClick = () => {
		const { onSelectChange, id, checked } = this.props;
		const { slug, data } = this.props.project;
		onSelectChange(id);
		const exData = { ...data, shoot_type_id: id, delivery_at_location: checked, step: this.props.history.location.pathname.slice(1).split('/')[1] };
		// checked ? (exData. = true) : (exData.delivery_at_location = false);
		this.props.putData(slug, exData);
		this.props.changeData();
	};

	render() {
		const { id, title, avatar, selected, checked, type_title } = this.props;
		return (
			<li className="col-6 col-sm-4 col-md-3 p-1" key={id}>
				<div className={`${styles.shootCard} ${selected ? styles.selected : ''}`} onClick={this.onClick}>
					<img src={`https://kadro.co${avatar}`} alt={`${avatar}`} />
					<p style={{ fontSize: title.length > 10 ? '0.84em' : '1em' }}>{type_title} {title}</p>
				</div>
			</li>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		state,
		project: state.project
	};
};
export default connect(mapStateToProps, { putData, changeData })(withRouter(Card));
